var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignPrivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.90039,
    y: 6.13184,
    width: 10.2,
    height: 9.31731,
    rx: 1.05,
    stroke: "#151F57",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85254 5.3998V4.71192C5.85254 4.37266 5.90643 4.03556 6.0122 3.71321L6.07253 3.52936C6.18682 3.18104 6.3801 2.86387 6.63727 2.60262V2.60262C6.89798 2.33777 7.21715 2.13771 7.56916 2.01851L7.73155 1.96353C8.05172 1.85511 8.38747 1.7998 8.7255 1.7998H9.27958C9.61761 1.7998 9.95336 1.85511 10.2735 1.96353L10.4359 2.01851C10.7879 2.13771 11.1071 2.33777 11.3678 2.60262V2.60262C11.625 2.86387 11.8183 3.18104 11.9325 3.52936L11.9929 3.71321C12.0986 4.03556 12.1525 4.37266 12.1525 4.71192V5.3998",
    stroke: "#151F57",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95418 11.1872L8.99824 11.012L9.04231 11.1872L9.32204 12.2998H8.67444L8.95418 11.1872ZM9.19485 10.5226L8.99824 10.7572L8.80163 10.5226L8.43375 10.0836C8.28511 9.90629 8.28511 9.64786 8.43375 9.47051C8.52443 9.36231 8.65836 9.2998 8.79954 9.2998H9.19694C9.33812 9.2998 9.47205 9.36231 9.56274 9.47051C9.71138 9.64786 9.71138 9.90629 9.56274 10.0836L10.1376 10.5654L9.56274 10.0836L9.19485 10.5226Z",
    stroke: "#151F57",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignPrivateIcon);
export default __webpack_public_path__ + "static/media/assign_private_icon.6c5ff07f86248f98642e363d6b3896a9.svg";
export { ForwardRef as ReactComponent };